import { createAction, createReducer } from "@reduxjs/toolkit";

const ActionButtonLoader = createAction("ActionButtonLoader");

// reducers.js
const initialState = {
  buttonaction: {
    status: 0,
    message: "",
    icon: 0,
  },
};

export const buttonLoaderReducer = createReducer(initialState, (builder) => {
  builder.addCase(ActionButtonLoader, (state, action) => {
    state.buttonaction = action.payload;
  });
});
